/**
 * 指定された引数が文字列かどうかを取得します
 *
 * @param mayString 文字列かどうかを判定する何か
 */
export function isString(mayString: unknown): mayString is string {
  return typeof mayString == "string" || mayString instanceof String;
}

/**
 * 指定された引数がオブジェクトかどうかを取得します
 *
 * @param mayObject オブジェクトかどうかを判定する何か
 */
export function isObject(mayObject: unknown): mayObject is object {
  return typeof mayObject === 'object' && mayObject !== null && !Array.isArray(mayObject);
}

/**
 * 指定された引数が空のオブジェクトかどうかを取得します
 *
 * @param mayEmptyObject オブジェクトが空かどうかを判定する何か
 */
export function isEmptyObject(mayEmptyObject: unknown): boolean {
  return isObject(mayEmptyObject) && Object.keys(mayEmptyObject).length === 0;
}

/**
 * 指定された引数が関数かどうかを取得します
 *
 * @param mayFunction 関数かどうかを判定する何か
 */
export function isFunction(mayFunction: unknown): mayFunction is Function {
  return typeof mayFunction === 'function';
}

/**
 * 指定された引数が Date かどうかを取得します
 *
 * @param mayDate Date かどうかを判定する何か
 */
export function isDate(mayDate: unknown): mayDate is Date {
  return mayDate instanceof Date;
}

/**
 * 指定された引数が null または undefined かどうかを取得します
 *
 * @param mayNullish null または undefined かどうかを判定する何か
 */
export function isNullish(mayNullish: unknown): mayNullish is null | undefined {
  return mayNullish === null || mayNullish === undefined;
}

/**
 * 引数を消費するだけで何も行いません
 *
 * @param values 任意の引数
 */
export function noop(...values: any): void {
  // do nothing
}
